import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-row">
        <nav className="footer-links" aria-label="Footer">
          <a href="#portfolio">Work</a>
          <a href="#services">Services</a>
          <a href="#about">How we work</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>
      <img
        className="footer-mark"
        src={`${process.env.PUBLIC_URL}/omnistrix-wordmark-light.png`}
        alt=""
        width="1341"
        height="270"
        loading="lazy"
      />
      <p className="footer-legal">&copy; {currentYear} Omnistrix Solution. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
